import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };

  data;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) {

     }



  ngOnInit(): void {
this.getRealTimeData();
  }

  getRealTimeData(){
    this.http.get(environment.ADMIN_REALTIME_DATA, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          console.log(res.message)
          this.data = res.message;
        }
        else {
          console.log('No data')
        }
        
      }, (err: any) => {

      }
    )
  }

}
